import React, { useContext, useMemo } from 'react'
import FrontPageReviewCard from './FrontPageReviewCard'
import CardCarousel from 'components/Luxkit/Carousel/CardCarousel'
import GeoContext from 'contexts/geoContext'
import getFrontPageReviews from 'constants/frontPageReviews'

function FrontPageReviews() {
  const { currentRegionCode } = useContext(GeoContext)

  const reviews = useMemo(() => getFrontPageReviews(currentRegionCode) || [], [currentRegionCode])

  return (
    <CardCarousel snap="start" gap={32}>
      {reviews.map((review, index) => (
        <FrontPageReviewCard key={index} {...review} />
      ))}
    </CardCarousel>
  )
}

export default FrontPageReviews
